import React, { useCallback, useEffect, useRef } from "react";
import { Select, Flex, Form, Button } from "antd";
import { create } from "zustand";
import { MasterType } from "pages/admin/objectsAndClients/objects/types";

type ComponentProps = {
  mastersList: { isLoaded: boolean; data: MasterType[] };
  masters: MasterType[];
  setIsAddMasterMode: (isAddMasterMode: boolean) => void;
  setMasters: (update: (state: MasterType[]) => MasterType[]) => void;
};

type MastersStoreState = {
  isSubmittable: boolean;
  setIsSubmittable: (isSubmittable: boolean) => void;
};

const useMastersStore = create<MastersStoreState>((set) => ({
  isSubmittable: false,
  setIsSubmittable: (isSubmittable) => set({ isSubmittable }),
}));

const Component: React.FC<ComponentProps> = ({
  mastersList,
  masters,
  setIsAddMasterMode,
  setMasters,
}) => {
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);

  const valuesRef = useRef(values);

  //  Save current list to the ref so we can use it in useEffect without trigger it
  useEffect(() => {
    valuesRef.current = values;
  }, [values]);

  const { isSubmittable, setIsSubmittable } = useMastersStore((store) => store);

  //  Effect triggers when mode changes to add. Also when some value changes. It fires validation and reset error.
  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setIsSubmittable(true))
      .catch(() => setIsSubmittable(false));
  }, [form, values, setIsSubmittable]);

  //  Submit form, depends of mode
  const handleFinish = useCallback(() => {
    try {
      const masterId = values.masterId;

      const master = mastersList.data.find(
        (mastersListItem) => mastersListItem.id === masterId
      );

      setMasters((masters) => {
        const newMasters = [...masters];

        if (master) newMasters.push(master);

        return newMasters;
      });
    } catch (error) {
      console.log(error);
    }

    setIsAddMasterMode(false);
  }, [setMasters, values, mastersList, setIsAddMasterMode]);

  return (
    <>
      <Flex vertical gap={16}>
        <Form
          layout={"vertical"}
          form={form}
          onFinish={handleFinish}
          initialValues={{
            name: "",
            file: null,
          }}
        >
          <Form.Item
            name="masterId"
            label="Мастер"
            rules={[
              {
                required: true,
                message: "Пожалуйста, выберите мастера!",
              },
            ]}
            validateTrigger={false}
            required={false}
          >
            <Select placeholder="Выберите мастера">
              {mastersList.data
                .filter(
                  (mastersListItem) =>
                    !masters
                      .flatMap((master) => master.id)
                      .includes(mastersListItem.id)
                )
                .map((master, index) => (
                  <Select.Option key={index} value={master.id}>
                    {master.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              size="large"
              disabled={!isSubmittable}
              htmlType="submit"
            >
              Сохранить
            </Button>
          </Form.Item>
        </Form>
      </Flex>
    </>
  );
};

export default Component;
